import view from './view.html';

/* @ngInject */
export default function () {
	return {
		replace:                    true,
		template:                   view,
		scope:                      {
			start:          '=',
			end:            '=',
			dateFormat:     '=',
			config:         '=?config', // https://code.angularjs.org/1.6.6/docs/error/$compile/nonassign?p0=undefined&p1=config&p2=datetimeRangePicker
			onSetStartTime: '=',
			onSetEndTime:   '=',
		},
		controller: /* @ngInject */ ($scope) => {
			$scope.onSetStartTimeCallback = (newTime, oldTime) => {
				if ($scope.onSetStartTime) {
					$scope.onSetStartTime(newTime, oldTime);
				}
			};

			$scope.onSetEndTimeCallback = (newTime, oldTime) => {
				if ($scope.onSetEndTime) {
					$scope.onSetEndTime(newTime, oldTime);
				}
			};

			if (!$scope.config) {
				$scope.config = {};
			}

			$scope.config = {
				...$scope.config,
				modelType: 'moment',
			};
		},
		link:                       (scope, element, attrs) => {

		},
	};
};


// WEBPACK FOOTER //
// ./src/js/directives/datetimeRangePicker/index.js